
import './ActivitiesCard.scss';

const ActivitiesCard = ({ activityName, activityData, lastActivitiesData = false }) => {

	return(
		<div className="activities-card">
            <div className={"activities-data" + (lastActivitiesData ? " last-activities-data" : "")}>
				{activityData}
			</div>
			<div className="activities-name">
				{activityName}
			</div>
		</div>
	)
}

export default ActivitiesCard;